export default "__VITE_ASSET__NTHE9kSQ__"